import { createContext } from 'react';

import { TrackEventHandlersMap } from '../types/event-handlers.js';

export const TrackEventHandlersContext = createContext<
  TrackEventHandlersMap | undefined
>(undefined);
